import { render, staticRenderFns } from "./WxRedirect.vue?vue&type=template&id=65eefcc6&scoped=true&"
import script from "./WxRedirect.vue?vue&type=script&lang=js&"
export * from "./WxRedirect.vue?vue&type=script&lang=js&"
import style0 from "./WxRedirect.vue?vue&type=style&index=0&id=65eefcc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65eefcc6",
  null
  
)

export default component.exports